var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadge1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5681 1.66843C11.4611 1.18336 12.5389 1.18336 13.4319 1.66843L17.22 3.72604L20.8796 5.78821C21.8153 6.31551 22.3978 7.30286 22.4067 8.37693L22.44 12.3906L22.4067 16.4043C22.3978 17.4784 21.8153 18.4657 20.8796 18.993L17.22 21.0552L13.4319 23.1128C12.5389 23.5979 11.4611 23.5979 10.5681 23.1128L6.78 21.0552L3.12042 18.993C2.18466 18.4657 1.6022 17.4784 1.59329 16.4043L1.56 12.3906L1.59329 8.37693C1.6022 7.30286 2.18466 6.31551 3.12042 5.7882L6.78 3.72604L10.5681 1.66843Z",
    fill: "#FCD34D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3253 8.16335V16.8906H11.7443V9.7017H11.6932L9.65199 11.0057V9.55682L11.821 8.16335H13.3253Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge1);
export default __webpack_public_path__ + "static/media/badge_1.5e177b3c531a5f74b16c9df5b5e52fd5.svg";
export { ForwardRef as ReactComponent };